import { FC } from 'react';
import { Rating } from '@mui/material';
import GoogleAvatar from 'src/components/Items/Filters/ReviewModal/Card/GoogleAvatar';
import { fromISOtoFormat } from 'src/common/utils/dataFormat';
import { IHostFeedback } from 'src/store/reducers/host/types';
import './styles.scss';
import './media.scss';

interface IProps {
  feedback: IHostFeedback;
}

const FeedbackCard: FC<IProps> = ({ feedback }) => {
  const { photo, rates, client_name, description, created_at, van_name, link } = feedback;

  return (
    <div className='feedback-card'>
      <div className='feedback-card__van'>
        <img src={photo[0]} alt='van photo' loading='lazy' />
        <h6>{van_name}</h6>
      </div>
      <div className='feedback-card__container'>
        <div className='feedback-card__info'>
          <div className='feedback-card__info__wrapper'>
            <div className='feedback-card__info__rating'>
              <Rating value={rates} precision={0.5} readOnly />
              <div>{rates}</div>
            </div>
            <p>
              {client_name} - {fromISOtoFormat(created_at, 'MMMM yyyy')}
            </p>
          </div>
          <GoogleAvatar name={client_name} />
        </div>
        <p>
          {description}&nbsp;
          {link ? (
            <a href={link} target='_blank'>
              more details
            </a>
          ) : (
            <></>
          )}
        </p>
      </div>
    </div>
  );
};
export default FeedbackCard;
